import api from "./api";

export const authService = {
  register: async (userData) => {
    const response = await api.post("/auth/register", userData);
    return response.data;
  },

  login: async (credentials) => {
    const response = await api.post("/auth/login", credentials);
    return response.data;
  },

  getMe: async () => {
    const response = await api.get("/auth/me");
    return response.data.data.user; // Just the user object
  },

  updateProfile: async (profileData) => {
    const response = await api.put("/auth/profile", profileData);
    return response.data;
  },

  updateAgentDetails: async (agentData) => {
    const response = await api.put("/auth/agent-details", agentData);
    return response.data;
  },

  updateSpotlightLocations: async (spotlightLocations) => {
    const response = await api.put("/auth/spotlight-locations", { spotlightLocations });
    return response.data;
  },

  changePassword: async (passwordData) => {
    const response = await api.put("/auth/change-password", passwordData);
    return response.data;
  },

  requestPasswordReset: async (payload) => {
    const response = await api.post("/auth/forgot-password", payload);
    return response.data;
  },

  verifyPasswordResetOtp: async (payload) => {
    const response = await api.post("/auth/verify-reset-otp", payload);
    return response.data;
  },

  resetPassword: async (payload) => {
    const response = await api.post("/auth/reset-password", payload);
    return response.data;
  },

  requestPhoneVerificationOtp: async (payload) => {
    const response = await api.post("/auth/phone/request-otp", payload);
    return response.data;
  },

  verifyPhoneVerificationOtp: async (payload) => {
    const response = await api.post("/auth/phone/verify-otp", payload);
    return response.data;
  },

  requestAgentPhoneVerificationOtp: async (payload) => {
    const response = await api.post("/agent/phone/request-otp", payload);
    return response.data;
  },

  verifyAgentPhoneVerificationOtp: async (payload) => {
    const response = await api.post("/agent/phone/verify-otp", payload);
    return response.data;
  },

  registerAsAgent: async (agentData) => {
    const response = await api.post("/agent/register", agentData);
    return response.data;
  },

  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },

  isAuthenticated: () => {
    return !!localStorage.getItem("token");
  },

  getStoredUser: () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  storeUser: (user) => {
    if (!user) return;
    localStorage.setItem("user", JSON.stringify(user));
  },

  storeToken: (token) => {
    localStorage.setItem("token", token);
  },
};
